import './cmw-landing.scss';

// share section
const shareContainer = document.querySelector('.share-container');
const shareBtn = document.querySelector('.share-btn');
const closeSahre = document.querySelector('.close-share');


shareBtn.addEventListener('click', e => {
    shareContainer.classList.add('open');
})

closeSahre.addEventListener('click', e => {
    shareContainer.classList.remove('open');
})



// scroll btns
const knowMoreBtn = document.querySelector('.know-more');
const features = document.querySelector('.features');

knowMoreBtn.addEventListener('click', e => {
    window.scroll({ top: features.offsetTop + 10, behavior: 'smooth' });
})

window.onload = function (e) {

    // if ('loading' in HTMLImageElement.prototype) {
    //     const images = document.querySelectorAll("img.lazyload");
    //     images.forEach(img => {
    //         img.src = img.dataset.src;
    //     });
    // } else {
        let script = document.createElement("script");
        script.async = true;
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js";
        document.body.appendChild(script);
    // }
}


import MicroModal from 'micromodal';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

MicroModal.init();


const tel = document.querySelector('[type=tel]')

intlTelInput(tel, {
    numberType: 'MOBILE',
    initialCountry: "sd",
    defaultCountry: "sd",
    nationalMode: false,
    autoHideDialCode: false
});

let mainButtons = document.querySelectorAll('[show-modal="true"]')


if(mainButtons.length) {
    mainButtons.forEach(btn => {
        btn.addEventListener('click', ev => {
            ev.preventDefault();
            MicroModal.show('login-modal');
        });
    })
}


const loginForm = document.querySelector('.login-form');
const errorMessage = loginForm.querySelector('.error-message');


loginForm.addEventListener('submit', ev => {
    ev.preventDefault()
    errorMessage.textContent = '';
    let req = fetch(`${BASE.url}login`,{
        method: 'post',
        headers: {
            'ApiKey': 'd5ab8dc7ef67ca92e41d730982c5c602',
        },
        body: new FormData(loginForm);
    })

    req.then(res => res.json())
        .then(res => {
            if(res.status == 1) {
                window.location.href = `${BASE.url}profile/business`;
            } else {
                errorMessage.textContent = res.message;
            }
        })
})
